import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../cn";

export type PropsRkSection = HTMLAttributes<HTMLElement> & {
  readonly tom?: "canvas" | "subtle";
  readonly hero?: boolean;
  readonly eyebrow?: string;
  readonly titulo?: string;
  readonly lead?: string;
  readonly alinhamento?: "left" | "center";
  readonly children?: ReactNode;
};

export function Section({
  tom = "canvas",
  hero = false,
  eyebrow,
  titulo,
  lead,
  alinhamento = "left",
  className,
  children,
  ...resto
}: PropsRkSection) {
  return (
    <section
      {...resto}
      className={cn(
        "rk-section",
        tom === "canvas" ? "rk-section--canvas" : "rk-section--subtle",
        hero && "rk-section--hero",
        className,
      )}
    >
      <div className="rk-container">
        {(eyebrow || titulo || lead) && (
          <div
            className={cn(
              "rk-section__eyebrow-block",
              alinhamento === "center" && "rk-section__eyebrow-block--center",
            )}
          >
            {eyebrow ? <p className="rk-eyebrow">{eyebrow}</p> : null}
            {titulo ? <h2 className="rk-display-md">{titulo}</h2> : null}
            {lead ? <p className="rk-body-lg">{lead}</p> : null}
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
